module.exports = nativescript-xmpp-client;